export const DOCUMENTATION_SET = 'DOCUMENTATION_SET';
export const DOCUMENTATION_COUNT_SET = 'DOCUMENTATION_COUNT_SET';
export const DOCUMENTATION_RESET = 'DOCUMENTATION_RESET';
export const DOCUMENTATION_PREFIX_SET = 'DOCUMENTATION_PREFIX_SET';
export const DIRECTORY_SET = 'DIRECTORY_SET';
export const ADVANCED_DOCUMENTS_LOADED = 'ADVANCED_DOCUMENTS_LOADED';
